import { useState } from 'react';

/**
 *
 * @param {Array<import("../../data/types/types").TemplatePreview>} preview
 * @returns {import("../../data/types/types").GetPreviewDataHookReturn}
 */
export const useGetPreviewData = (preview) => {
  const [dataRowNum, setDataRowNum] = useState(0);

  /**
   * Resets the row number to 0
   * @returns {void}
   */
  const resetRowNumber = () => {
    setDataRowNum(0);
  };

  /**
   * Returns the next data row
   * @returns {void}
   */
  const getNextDataRow = () => {
    if (preview.length > dataRowNum + 1) {
      setDataRowNum(dataRowNum + 1);
    }
  };

  /**
   * Returns the current row number
   * @returns {number}
   */
  const getCurrentRowNumber = () => {
    return dataRowNum + 1;
  };

  /**
   * Returns the total number of rows
   * @returns {number}
   */
  const getRowNumbers = () => {
    return preview.length;
  };

  /**
   * Returns the previous data row
   * @returns {void}
   */
  const getPreviousDataRow = () => {
    if (dataRowNum > 0) {
      setDataRowNum(dataRowNum - 1);
    }
  };

  /**
   * @param {string} csvColumn
   * @returns {string}
   */
  const getCsvColumnFromDefinition = (csvColumn) => {
    if (!preview.length) {
      return '';
    }

    const dataRow = preview[dataRowNum];

    if (!dataRow) {
      return '';
    }

    return dataRow[csvColumn];
  };

  return {
    getNextDataRow,
    getPreviousDataRow,
    getCsvColumnFromDefinition,
    getRowNumbers,
    getCurrentRowNumber,
    resetRowNumber,
  };
};
